
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog-post/2020/10/the-fake-reviews-economy",
      function () {
        return require("private-next-pages/blog-post/2020/10/the-fake-reviews-economy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog-post/2020/10/the-fake-reviews-economy"])
      });
    }
  